import React from 'react';
import { withTranslation } from 'react-i18next';
import { Container } from 'reactstrap';
import ManageDuplicates from './ManageDuplicates';
import BreadCrumb from '../BreadCrumb';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useCompanyName } from "../ThemeSettings/themeutitlity";

const ManageDeDupeContainer = (props: any) => {
	document.title = `DTS | ${useCompanyName()} - Reports`;
     const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    const query = useQuery();
    const model = query.get("model") || ''; // will be "students"
    const capitalizedModel = _.startCase(model)
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={ capitalizedModel || ''} pageTitle={'Manage Duplicates'} icon="ri-list-check" />
                    <ManageDuplicates />
                </Container>
            </div>
        </React.Fragment>
    );
};
export default withTranslation()(ManageDeDupeContainer);


